<template>
  <div id="publishing-reviewer-board">
    <div class="ipub-h1 mar-b-20 line-h-40 relative">
      Reviewer Board
      <div class="ipub-p1 right-option">
        <!-- <ipub-button v-show="user.codeList&&user.codeList.includes('WEBSITE.REVIEWER_BOARD.APPLY')"
                     type="primary"
                     @click="application">
          Reviewer Board Application
        </ipub-button> -->
        <ipub-button v-show="params.journalId&&user.codeList&&user.codeList.includes('WEBSITE.REVIEWER_BOARD.CREATE_NEW')"
                     type="primary"
                     @click="add">
          Add New Member </ipub-button>
        <ipub-button v-if="user.codeList&&user.codeList.includes('WEBSITE.REVIEWER_BOARD.EXPORT')"
                     :loading="loading"
                     type="primary"
                     @click="exp">
          Export
        </ipub-button>
        <ipub-button v-if="user.codeList&&user.codeList.includes('WEBSITE.REVIEWER_BOARD.IMPORT')"
                     type="primary"
                     v-show="params.journalId"
                     @click="imp()">
          Import
        </ipub-button>
      </div>
    </div>
    <div class="ipub-filter-div">
      <div class="ipub-filter-div-content">
        <ipub-row :gutter="[12,16]">
          <ipub-col :span="2">
            <ipub-select v-model="params.journalId"
                         placeholder="Select Journal"
                         @change="changeJournal">
              <ipub-select-option :value="''">All</ipub-select-option>
              <ipub-select-option :value="item.id"
                                  v-for="item in journalList"
                                  :key="item.id+'dialog'">
                {{item.name}}
              </ipub-select-option>
            </ipub-select>
          </ipub-col>
          <ipub-col :span="10">
            <site-search-group v-model.trim="params.keyword"
                               placeholder="Search by reviewer board member's name, email"
                               @search="getList()"
                               @clear="handleClear" />
          </ipub-col>
        </ipub-row>
        <ipub-row :gutter="[12,16]"
                  v-if="showAdv">
          <ipub-col :span="8">
            <div class="flex">
              <span class="line-h-40 ipub-p2 fw-bd ipub-nowrap">Country / Territory</span>
              <ipub-select v-model="params.countryCode"
                           search
                           @search="countrySearch"
                           @change="getList()"
                           class="mar-l-12"
                           placeholder="Select Country / Territory">
                <ipub-select-option v-for="item in countryList"
                                    :value="item.code"
                                    :key="'countryList'+item.code">
                  {{item.name}} <template v-if="item.otherName">({{item.otherName}})</template>
                </ipub-select-option>
              </ipub-select>
            </div>
          </ipub-col>
          <!-- <ipub-col :span="8">
            <div class="flex">
              <span class="line-h-40 nowrap">Personal Classficiation</span>
              <ipub-select placeholder="Select Personal Classficiation"
                           v-model="params.categoryIdList"
                           class="mar-l-12"
                           :tree="true"
                           @change="getList()"
                           :options="categoryList" />
            </div>
          </ipub-col> -->
        </ipub-row>
      </div>
      <a class="ipub-filter-div-button"
         @click="()=>{showAdv = !showAdv}">
        Advanced
        <ipub-icon :class="['mar-l-10 rotate',showAdv?'rotate-180':'']"
                   type="iconArrow" />
      </a>
    </div>

    <div class="ipub-list-tab">
      <a @click="changeStatus('')"
         :class="['ipub-list-tab--status',params.released===''?'active':'']">All Status</a>
      <a @click="changeStatus(true)"
         :class="['ipub-list-tab--status',params.released===true?'active':'']">Published</a>
      <a @click="changeStatus(false)"
         :class="['ipub-list-tab--status',params.released===false?'active':'']">Draft</a>
    </div>
    <div class="page-content">
      <ipub-table :columns="columns"
                  fixed
                  :empty="{icon:'iconuser'}"
                  emptyText="There is no reviewer."
                  :pagination="pagination"
                  :dataSource="dataSource">
        <template v-slot:email="{ record }">
          <ipub-tooltip>
            <div slot="title">{{record.email}}</div>
            <div class="ipub-c-p link-color"
                 style="width:200px; overflow: hidden; text-overflow: ellipsis;white-space: nowrap"
                 @click="detail(record)">{{record.email}}</div>
          </ipub-tooltip>
        </template>
        <template v-slot:personName="{ record }">
          <ipub-tooltip style="width:100%"
                        placement="bottomLeft"
                        omis="omis"
                        :label="`${record.firstName} ${record.lastName}`" />
        </template>
        <template v-slot:country="{text}">
          <ipub-tooltip v-if="text"
                        style="width:100%"
                        placement="bottomLeft"
                        omis="omis"
                        :label="`${country[text]}`" />
          <template v-else>--</template>
        </template>
        <template v-slot:name="{ record }">
          <ipub-tooltip class="border-right"
                        v-if="record.operator">
            <div slot="title">{{record.operator.firstName}} {{record.operator.lastName}}</div>
            {{record.operator.firstName}} {{record.operator.lastName}}
          </ipub-tooltip>
          <template v-else>--</template>
        </template>
        <template v-slot:status="{text}">
          <template v-if="text">
            <ipub-label cover
                        style="width:80px"
                        type="success"
                        size="small">Published</ipub-label>
          </template>
          <template v-else>
            <ipub-label cover
                        style="width:80px"
                        type="danger"
                        size="small">Draft</ipub-label>
          </template>
        </template>
        <template v-slot:actions="{ record }">
          <ipub-tooltip v-show="user.codeList&&(user.codeList.includes('WEBSITE.REVIEWER_BOARD.EDIT')||(user.codeList.includes('WEBSITE.REVIEWER_BOARD.UNPUBLISHED_EDIT')&&!record.released))"
                        class="border-right">
            <div slot="title">Details</div>
            <ipub-icon type="iconViewDetails"
                       @click="detail(record)" />
          </ipub-tooltip>
          <template v-if="user.codeList&&user.codeList.includes('WEBSITE.REVIEWER_BOARD.PUBLISH')">
            <div v-show="params.journalId">
              <ipub-tooltip class="border-right"
                            v-if="record.released">
                <div slot="title">Unpublish</div>
                <ipub-icon type="iconDisable"
                           @click="able(record)" />
              </ipub-tooltip>
              <ipub-tooltip class="border-right"
                            v-else>
                <div slot="title">Publish</div>
                <ipub-icon type="iconAble"
                           @click="able(record)" />
              </ipub-tooltip>
            </div>
          </template>
          <ipub-tooltip class="border-right"
                        v-show="params.journalId&&user.codeList&&(user.codeList.includes('WEBSITE.REVIEWER_BOARD.DOWNLOAD_BANNER')||user.codeList.includes('WEBSITE.REVIEWER_BOARD.DOWNLOAD_CERTIFICATE'))"
                        placement="bottomRight"
                        type="light"
                        action="click">
            <div class="hover-action-content"
                 style="font-size:14px;"
                 slot="title">
              <div class="flex ipub-c-p"
                   v-if="user.codeList&&user.codeList.includes('WEBSITE.REVIEWER_BOARD.DOWNLOAD_BANNER')"
                   @click="createCanvans(record, 'rb-b')">
                <ipub-icon type="iconBanner" />
                Banner
              </div>
              <div class="flex ipub-c-p"
                   v-if="user.codeList&&user.codeList.includes('WEBSITE.REVIEWER_BOARD.DOWNLOAD_CERTIFICATE')"
                   @click="createCanvans(record, 'rb-c')">
                <ipub-icon type="iconCertificate" />
                Certificate
              </div>
            </div>
            <ipub-icon type="iconGenerator" />
          </ipub-tooltip>
          <ipub-tooltip v-show="user.codeList&&user.codeList.includes('WEBSITE.REVIEWER_BOARD.DELETE')">
            <div slot="title">Delete</div>
            <ipub-icon type="iconDelete"
                       @click="del(record)" />
          </ipub-tooltip>
        </template>
      </ipub-table>
    </div>
    <Add ref="reviewer-board-add"
         :isVisable="isVisable"
         :inputData="inputData"
         :journalId="params.journalId"
         :journalList="journalList"
         @confirm="confirm"
         @cancel="cancel" />
    <import-dialog :isVisable="isVisableImport"
                   :journalId="params.journalId"
                   @confirm="confirm"
                   @cancel="cancel" />
    <CreatePNG :isVisable="isVisablePDF"
               :inputData="inputData"
               :type="pdfType"
               :journalId="params.journalId"
               @confirm="cancel"
               @cancel="cancel" />
  </div>
</template>

<style lang="scss" scoped>
@import './main.scss';
</style>

<script>
import main from './main'
export default main
</script>
